var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgStarEmpty = function SvgStarEmpty(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38.425,
    height: 35.681,
    viewBox: "0 0 38.425 35.681",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ios-star-outline",
    d: "M68.967,60.351H56.35L52.516,48.909a1.389,1.389,0,0,0-2.607,0L46.075,60.351h-12.7A1.376,1.376,0,0,0,32,61.723a1.008,1.008,0,0,0,.026.232,1.319,1.319,0,0,0,.575.969l10.37,7.308L38.99,81.8a1.376,1.376,0,0,0,.472,1.544,1.327,1.327,0,0,0,.772.335,1.682,1.682,0,0,0,.858-.309l10.121-7.213,10.121,7.213a1.607,1.607,0,0,0,.858.309,1.232,1.232,0,0,0,.763-.335,1.359,1.359,0,0,0,.472-1.544l-3.98-11.57L69.73,62.856l.249-.214a1.312,1.312,0,0,0-1.012-2.29Zm-10.91,7.934a2.409,2.409,0,0,0-.875,2.728l2.582,7.522a.344.344,0,0,1-.523.395L52.6,74.194a2.4,2.4,0,0,0-1.4-.446,2.352,2.352,0,0,0-1.389.446L43.176,78.92a.343.343,0,0,1-.523-.395L45.234,71a2.417,2.417,0,0,0-.883-2.745l-6.947-4.9a.345.345,0,0,1,.2-.626h8.466A2.4,2.4,0,0,0,48.339,61.1l2.539-7.565a.345.345,0,0,1,.652,0L54.069,61.1a2.4,2.4,0,0,0,2.273,1.638h8.345a.339.339,0,0,1,.2.618Z",
    transform: "translate(-32 -48)",
    fill: "#e2e2e2"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgStarEmpty, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/star-empty.07d7b5c0.svg";
export { ForwardRef as ReactComponent };